import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-expired-product-summary-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expired-product-summary-chart.component.html',
  styleUrl: './expired-product-summary-chart.component.scss'
})
export class ExpiredProductSummaryChartComponent {
  @Input() isLoadingExpiredSummary: boolean = false;
  @Input() expiredSummaryData: any[] = [];
}
